import React from 'react';
import { QuestionComponentProps, QuestionData } from '../../type';
import { options_TickTFCharacter } from 'constants/question_data/questionConfig';

const TickTF_Results = ({ questionIndex, questionData, isCombineChild }: QuestionComponentProps) => {
  const { answers, audioUrl ,optionType} = questionData;
  const TFtext = options_TickTFCharacter.find((i) => i.optionType === optionType)?.value;

  return (
    <div style={{ display: 'flex', gap: 5 }}>
      <div>{isCombineChild ? <i>{questionIndex + 1}.</i> : <span>{questionIndex + 1}.</span>}</div>
      <div>
        <div>
          Answer:{' '}
          {answers.map((answer, index) => {
            return <>&emsp; {answer.isCorrect ? TFtext.icon1 ?? 'true' : TFtext.icon2 ?? 'false'},</>;
          })}
        </div>
        {audioUrl ? <div>Audio: {audioUrl}</div> : null}
      </div>
    </div>
  );
};

export default TickTF_Results;
